import React, { useState } from 'react';
import { FIELD_NAME } from '../../../constants/form-constants';
import { STYLED_DOUBLE_SELECT } from '../../../constants/styles-constants';
import { formService } from '../../../form-service';
import { isComerciales } from '../../../helpers/carline-helpers';
import { SelectExtended } from './core/select-extended';
import { TextInputExtended } from './core/text-input-extended';

interface Props {
	label?: string;
	required?: boolean;
	hidePrefijo?: boolean;
	labelPrefijo?: string;
}

const regExpSpain = /[6|7|8|9][0-9]{8}/gi;
const regExpInternational = /^[0-9][0-9\s\-\(\)]*[0-9]$|^[0-9]$/;

export const phonePrefixes = [
	'+1',
	'+7',
	'+20',
	'+27',
	'+30',
	'+31',
	'+32',
	'+33',
	'+34',
	'+36',
	'+39',
	'+40',
	'+41',
	'+43',
	'+44',
	'+45',
	'+46',
	'+47',
	'+48',
	'+49',
	'+51',
	'+52',
	'+53',
	'+54',
	'+55',
	'+56',
	'+57',
	'+58',
	'+60',
	'+61',
	'+62',
	'+63',
	'+64',
	'+65',
	'+66',
	'+81',
	'+82',
	'+84',
	'+86',
	'+90',
	'+91',
	'+92',
	'+93',
	'+94',
	'+95',
	'+98',
	'+212',
	'+213',
	'+216',
	'+218',
	'+351',
	'+352',
	'+353',
	'+354',
	'+355',
	'+356',
	'+358',
	'+359',
	'+370',
	'+371',
	'+372',
	'+373',
	'+374',
	'+375',
	'+376',
	'+377',
	'+380',
	'+381',
	'+382',
	'+385',
	'+386',
	'+387',
	'+389',
	'+420',
	'+421',
	'+423',
	'+506',
	'+591',
	'+852',
	'+853',
	'+880',
	'+886',
	'+971',
	'+972',
	'+973',
	'+994',
	'+998',
];

export function TelefonoInput(props: Props) {
	const { label, hidePrefijo, labelPrefijo } = props;
	const [selectedPrefix, setSelectedPrefix] = useState('+34');

	const isSpanishPrefix = selectedPrefix === '+34';
	const maxLength = isSpanishPrefix ? 9 : 15;
	const minLength = isSpanishPrefix ? 9 : 7;
	const regExp = isSpanishPrefix ? regExpSpain : regExpInternational;

	const handlePrefixChange = (newPrefix: string) => {
		setSelectedPrefix(newPrefix);
		if (newPrefix === '+34') {
			const currentPhone = formService.getFieldValue(FIELD_NAME.PHONE) || '';
			if (currentPhone.length > 9) {
				formService.setFieldValue(FIELD_NAME.PHONE, currentPhone.slice(0, 9));
			}
		}
	};

	return (
		<div style={{ display: 'flex', flexDirection: 'row' }}>
			{(!hidePrefijo || isComerciales()) && (
				<div style={{ width: STYLED_DOUBLE_SELECT.first.width }}>
					<SelectExtended
						{...props}
						name={FIELD_NAME.PHONE_PREFIX}
						label={labelPrefijo ? labelPrefijo : 'Prefijo'}
						options={phonePrefixes}
						value={selectedPrefix}
						onChange={handlePrefixChange}
					/>
				</div>
			)}
			<div
				style={{
					width: hidePrefijo ? '100%' : STYLED_DOUBLE_SELECT.second.width,
					marginLeft: hidePrefijo ? 0 : STYLED_DOUBLE_SELECT.second.marginLeft,
				}}
			>
				<TextInputExtended
					{...props}
					name={FIELD_NAME.PHONE}
					label={label || 'Teléfono'}
					validate={(value) => regExp.test(value) && value.length >= minLength}
					errorMessage="Teléfono incorrecto"
					maxLength={maxLength}
				/>
			</div>
		</div>
	);
}
